import { render, staticRenderFns } from "./homeDashboardCenterMonthlyStatistics.vue?vue&type=template&id=22ff76ac&scoped=true"
import script from "./homeDashboardCenterMonthlyStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardCenterMonthlyStatistics.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardCenterMonthlyStatistics.vue?vue&type=style&index=0&id=22ff76ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ff76ac",
  null
  
)

export default component.exports